import { defineSlotRecipe } from '@chakra-ui/react';

export const rangePickerDrawerSlotRecipe = defineSlotRecipe({
    slots: ['button', 'footerContent'],
    base: {
        button: {
            colorPalette: 'secondary',
            w: '100%',
        },
        footerContent: {
            textAlign: 'center',
            fontSize: 'md',
        },
    },
});
